import styled from 'styled-components';
import { ILabel, IBox, IMark } from '.';

export const Label = styled.label<ILabel>`
    ${({ label }) =>
        !!label &&
        `
      display: flex;
      align-items: center;
    `}
    position: relative;
    height: 22px;
    cursor: pointer;
    user-select: none;
    color: #444;
    font-size: 15px;

    ${(props) => (props.label ? `padding-left: 30px;` : `padding-left: 20px;`)}

    ${({ readOnly, color }) =>
        !readOnly &&
        `
          &:hover span {
              background: ${color}1c};
          };
    `}

    input:checked ~ span {
        background: ${({ color }) => color};
    }
`;

export const Box = styled.input.attrs({
    type: 'checkbox',
})<IBox>`
    cursor: pointer;
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;

    &:checked ~ span:after {
        display: block;
    }
`;

export const Mark = styled.span<IMark>`
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background: rgba(255, 255, 255, 0.35);
    border: ${({ color }) => `2px ${color} solid`};
    border-radius: 3px;
    transition: 180ms ease-in-out;

    &:after {
        content: '';
        position: absolute;
        display: none;
        left: 5px;
        top: 2px;
        width: 40%;
        height: 60%;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`;
